import React from "react";
import { LinkTabView } from "./components";

export default function LinkTab({ informationId = 0, onActive = null }) {
	return <LinkTabView informationId={informationId} onActive={onActive} />;
}
